import { createGlobalStyle } from "styled-components";
import { fontFamily } from "@scriba/ui-lib";

export const GlobalStyles = createGlobalStyle`
  body {
    font-family: ${fontFamily("sansSerif")};
  }
`;
